export default __webpack_public_path__ + "static/media/South.5c217fb0.png";